import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from './shared/guards-inteceptor/auth.guard';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { SigninComponent } from './components/auth/signin/signin.component';
import { CategoryComponent } from './components/category/category.component';
import { CompanyDistributorsComponent } from './components/company/company-distributors/company-distributors.component';
import { SampleAllocatedToDisComponent } from './components/company/company-distributors/sample-allocated-to-dis/sample-allocated-to-dis.component';
import { SampleDistributedByDistributorsComponent } from './components/company/company-distributors/sample-distributed-by-distributors/sample-distributed-by-distributors.component';
import { CompanyComponent } from './components/company/company.component';
import { SamplesListComponent } from './components/company/samples-list/samples-list.component';
import { CustomersComponent } from './components/customers/customers.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { IssuedSamplesToAlldistributorsComponent } from './components/issued-samples-to-alldistributors/issued-samples-to-alldistributors.component';
import { CustomersSamplesReportComponent } from './components/Reports/customers-samples-report/customers-samples-report.component';
import { DistributorSamplesReportComponent } from './components/Reports/distributor-samples-report/distributor-samples-report.component';
import { RetailersComponent } from './components/retailers/retailers.component';
import { AddSampleComponent } from './components/sample/add-sample/add-sample.component';
import { AssignSampleComponent } from './components/sample/assign-sample/assign-sample.component';
import { EditSampleComponent } from './components/sample/edit-sample/edit-sample.component';
import { SampleComponent } from './components/sample/sample.component';
import { UsersComponent } from './components/users/users.component';
import { WholesalersComponent } from './components/wholesalers/wholesalers.component';
import { AdminComponent } from './layout/admin.component';
import { AddRolesPermissionComponent } from './roles-permission/add-roles-permission/add-roles-permission.component';
import { RolesPermissionComponent } from './roles-permission/roles-permission.component';
import { RtlUnderWhlComponent } from './components/wholesalers/rtl-under-whl/rtl-under-whl.component';
import { AllDistributorsComponent } from './components/all-distributors/all-distributors.component';
import { AssignSampleToDisComponent } from './components/sample/assign-sample-to-dis/assign-sample-to-dis.component';
import { DistributorDetailComponent } from './components/distributor-detail/distributor-detail.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login', pathMatch: 'full'
  },
  {
    path: 'login',
    component: SigninComponent
  },
  {
    path: 'reset-Password',
    component: ForgotPasswordComponent
  },
  {
    path: '', component: AdminComponent,
    canActivate: [authGuard], children: [

      {
        path: 'dashboard',
        component: DashboardComponent
      },

      {
        path: 'category',
        component: CategoryComponent
      },

      {
        path: 'company',
        component: CompanyComponent
      },
      {
        path: 'company/distribution/network/:companyId',
        component: CompanyDistributorsComponent
      },
      {
        path: 'sample',
        component: SampleComponent
      },
      {
        path: 'sample/add',
        component: AddSampleComponent
      },
      {
        path: 'sample/edit/:_id',
        component: EditSampleComponent
      },
      {
        path: 'sample/assign/:_id',
        component: AssignSampleComponent
      },

      {
        path: 'samples/assign/distributor/:distributorId/:distributorType',
        component: AssignSampleToDisComponent
      },
      {
        path: 'sample/issuedToDistributors/:receiverDistributorId/:distributorType',
        component: IssuedSamplesToAlldistributorsComponent
      },
      {
        path: 'wholesalers',
        component: WholesalersComponent
      },
      {
        path: 'retailers',
        component: RetailersComponent
      },
      {
        path: 'customers',
        component: CustomersComponent
      },
      {
        path: 'company/samples/:companyId',
        component: SamplesListComponent
      },
      {
        path: 'company/samples/distributed/:companyId/:distributorId/:distributorType',
        component: SampleAllocatedToDisComponent
      },
      {
        path: 'samples/distributedBy/distributors/:distributorId/:sampleId/:distributorType',
        component: SampleDistributedByDistributorsComponent

      },
      {
        path: 'users',
        component: UsersComponent
      },
      {
        path: 'roles',
        component: RolesPermissionComponent
      },
      {
        path: 'roles/add',
        component: AddRolesPermissionComponent
      },
      {
        path: 'roles/edit/:id',
        component: AddRolesPermissionComponent
      },
      {
        path: 'distributors/samples/report',
        component: DistributorSamplesReportComponent
      },
      {
        path: 'customer/samples/report',
        component: CustomersSamplesReportComponent
      },
      {
        path: 'retailer/underWhl/:wholesalerId',
        component: RtlUnderWhlComponent
      },
      {
        path: 'distributors/all',
        component: AllDistributorsComponent
      },
      {
        path: 'distributor/detail/:distributorId/:distributorType',
        component: DistributorDetailComponent
      },

    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
